import { ComponentPropsWithoutRef, forwardRef } from 'react';
import cn from 'classnames';

type VariantProps = {
  size: 's' | 'm' | 'l';
  variant: 'secondary01' | 'secondary02' | 'highlight' | 'primary';
} & ComponentPropsWithoutRef<'button'>;

type CommonProps = ComponentPropsWithoutRef<'button'> & {
  size?: never;
  variant?: never;
};

type ButtonProps = VariantProps | CommonProps;

const hasVariantProps = (props: ButtonProps): props is VariantProps => {
  return 'size' in props && 'variant' in props;
};

const getSizeClass = (size: 's' | 'm' | 'l') => {
  if (size === 's') return 'btn_small';
  if (size === 'm') return 'btn_medium';
  return 'btn_large';
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  if (hasVariantProps(props)) {
    const { size, variant, children, className, type = 'button', ...rest } = props;
    return (
      <button {...rest} ref={ref} type={type} className={cn(className, getSizeClass(size), `btn_${variant}`, 'btn')}>
        {children}
      </button>
    );
  }

  const { children, type = 'button', ...rest } = props;
  return (
    <button {...rest} ref={ref} type={type}>
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
